import React from "react";

const BulkSubcategoryModal = ({ show, combos, onSelect, onClose }) => {
  if (!show) return null;

  return (
    <div
      className="bulk-modal-overlay"
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}   // click outside closes
    >
      <div
        className="bg-white rounded shadow p-4"
        style={{ width: "90%", maxWidth: "400px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex justify-content-between mb-3">
          <h5 className="fw-bold m-0">Choose Bulk Combo Category</h5>

          {/* close button */}
          <button className="btn btn-sm btn-light" onClick={onClose}>
            ✕
          </button>
        </div>

        {combos.length === 0 ? (
          <p className="text-muted text-center">No bulk categories available</p>
        ) : (
          combos.map((combo) => (
            <button
              key={combo._id}
              className="btn btn-outline-dark w-100 mb-2"
              onClick={() =>
                onSelect({
                  subcategoryId: combo.subcategoryId._id,
                  comboId: combo._id,
                })
              }
            >
              {combo.subcategoryId.name}
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default BulkSubcategoryModal;
